import React, { useEffect, useContext } from 'react';

import i18n from '@components/i18n/i18n';
import { localeAvailable, handleChangeLng } from '@helpers/languages';
import i18nContext from '@components/i18n/i18nContext';

export const I18n = () => {
  //i18nLanguage is lucid.com lang setting
  const i18nLanguage = i18n.language;
  //navigatorLanguage is browser lang setting
  let navigatorLanguage;
  const { lng } = useContext(i18nContext);
  if (typeof window !== 'undefined') {
    navigatorLanguage =
      window.navigator.language || window.navigator.userLanguage;
    navigatorLanguage = navigatorLanguage.toLowerCase();
  }

  useEffect(() => {
    if (localeAvailable(navigatorLanguage)) {
      if (
        document.cookie.indexOf('i18next') !== -1 &&
        i18nLanguage === 'en' &&
        navigatorLanguage !== 'en'
      ) {

        handleChangeLng(navigatorLanguage, lng);
      }
    }
  }, []);

  return <></>;
};
